"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vsxTagConversion = void 0;
var bind_1 = __importDefault(require("classnames/bind"));
var react_1 = __importDefault(require("react"));
var R = __importStar(require("../../utils/ramda"));
var vsxTagConversion = function (nativeTagName) {
  return function (_a) {
    var children = _a.children,
      className = _a.className,
      row = _a.row,
      restProps = __rest(_a, ["children", "className", "row"]);
    var commonClasses = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(classesFromSizes("d", restProps)), false), __read(classesFromSizes("p", restProps)), false), __read(classesFromSizes("px", restProps)), false), __read(classesFromSizes("py", restProps)), false), __read(classesFromSizes("m", restProps)), false), __read(classesFromSizes("mx", restProps)), false), __read(classesFromSizes("my", restProps)), false), __read(classesFromSizes("g", restProps)), false), __read(classesFromSizes("gx", restProps)), false), __read(classesFromSizes("gy", restProps)), false);
    var containerClasses = classesFromSizes("container", restProps);
    var rowClasses = row ? __spreadArray(__spreadArray(["vsx-row"], __read(classesFromSizes("cols", restProps)), false), [restProps.justify && "justify-content-".concat(restProps.justify)], false) : [];
    var columnClasses = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(classesFromSizes("col", restProps)), false), __read(classesFromSizes("order", restProps)), false), __read(classesFromSizes("offset", restProps)), false), [restProps.align && "align-items-".concat(restProps.justify)], false);
    var vsxClassName = bind_1.default.apply(void 0, __spreadArray([], __read(R.uniq(__spreadArray(__spreadArray(__spreadArray(__spreadArray([className], __read(R.reject(R.isNothing, commonClasses)), false), __read(R.reject(R.isNothing, containerClasses)), false), __read(R.reject(R.isNothing, rowClasses)), false), __read(R.reject(R.isNothing, columnClasses)), false))), false));
    // @ts-ignore
    return react_1.default.createElement(nativeTagName, __assign({
      className: vsxClassName,
      children: children
    }, removeResponsiveProps(restProps)));
  };
};
exports.vsxTagConversion = vsxTagConversion;
var classesFromSizes = function (key, props) {
  var e_1, _a;
  var output = [];
  var sizes = ["", "-sm", "-md", "-lg", "-xl", "-xxl"];
  try {
    for (var sizes_1 = __values(sizes), sizes_1_1 = sizes_1.next(); !sizes_1_1.done; sizes_1_1 = sizes_1.next()) {
      var size = sizes_1_1.value;
      var prop = "".concat(key).concat(size);
      if (props[prop] !== undefined) {
        output.push("vsx-".concat(prop, "-").concat(props[prop]).replace(/-true/g, ""));
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (sizes_1_1 && !sizes_1_1.done && (_a = sizes_1.return)) _a.call(sizes_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  return output;
};
var reject = ["container", "row", "col", "d", "d-sm", "d-md", "d-lg", "d-xl", "d-xxl", "cols", "cols-sm", "cols-md", "cols-lg", "cols-xl", "cols-xxl", "justify", "col-sm", "col-md", "col-lg", "col-xl", "col-xxl", "order", "order-sm", "order-md", "order-lg", "order-xl", "order-xxl", "offset", "offset-sm", "offset-md", "offset-lg", "offset-xl", "offset-xxl", "align"];
var removeResponsiveProps = function (props) {
  return R.omit(reject, props);
};